class VariantMediaVisibility {
  constructor() {
    this.init();
  }

  init() {
    this.productForm = document.querySelector('variant-selects');
    if (!this.productForm) return;

    this.mediaGallery = document.querySelector('media-gallery');
    if (!this.mediaGallery) return;

    this.hasVariants = this.mediaGallery.getAttribute('has_variant') === 'true';
    if (!this.hasVariants) return;

    // Listen for variant changes
    this.productForm.addEventListener('change', this.onVariantChange.bind(this));
    
    // Run on initial load
    setTimeout(() => this.filterMediaForCurrentVariant(), 100);
  }

  onVariantChange(event) {
    setTimeout(() => this.filterMediaForCurrentVariant(), 100);
  }

  getCurrentVariantId() {
    // Try to get from URL first
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    if (variantId) return variantId;

    // Get from selected variant data
    const selectedVariantData = document.querySelector('[data-selected-variant]');
    if (!selectedVariantData) return null;

    try {
      const selectedVariant = JSON.parse(selectedVariantData.textContent);
      return selectedVariant.id;
    } catch (e) {
      console.error('Could not parse selected variant');
      return null;
    }
  }

  filterMediaForCurrentVariant() {
    const variantId = this.getCurrentVariantId();
    if (!variantId) return;

    // Get selected variant data
    const selectedVariantData = document.querySelector('[data-selected-variant]');
    if (!selectedVariantData) return;

    let selectedVariant;
    try {
      selectedVariant = JSON.parse(selectedVariantData.textContent);
    } catch (e) {
      return;
    }

    const featuredMediaId = selectedVariant.featured_media?.id;
    
    // Get all media items in the main gallery
    const mediaList = this.mediaGallery.querySelector('.product__media-list');
    if (!mediaList) return;
    
    const allMediaItems = mediaList.querySelectorAll('.product__media-item');
    let visibleCount = 0;
    
    allMediaItems.forEach((item) => {
      const slideId = item.getAttribute('id');
      const mediaId = item.getAttribute('data-media-id');
      
      // Determine if this item should be visible
      let shouldShow = false;
      
      // Always show variant metafield images (have 'Slide-slide' in ID)
      if (slideId && slideId.includes('Slide-slide')) {
        shouldShow = true;
      }
      // Show the featured image for current variant
      else if (mediaId && featuredMediaId && mediaId.includes(featuredMediaId)) {
        shouldShow = true;
      }
      
      if (shouldShow) {
        item.style.display = '';
        item.style.visibility = 'visible';
        item.style.position = 'relative';
        item.classList.remove('hidden');
        item.removeAttribute('hidden');
        visibleCount++;
      } else {
        item.style.display = 'none';
        item.style.visibility = 'hidden';
        item.style.position = 'absolute';
        item.classList.add('hidden');
        item.setAttribute('hidden', '');
      }
    });

    // Update thumbnails
    this.updateThumbnails(featuredMediaId);
    
    // Update slider
    this.updateSlider(visibleCount);
    
    // Update media counter
    this.updateMediaCounter(visibleCount);
  }

  updateThumbnails(featuredMediaId) {
    const thumbnailList = document.querySelector('.thumbnail-list');
    if (!thumbnailList) return;
    
    const thumbnails = thumbnailList.querySelectorAll('.thumbnail-list__item');
    
    thumbnails.forEach((thumb) => {
      const thumbId = thumb.getAttribute('id');
      const dataTarget = thumb.getAttribute('data-target');
      
      let shouldShow = false;
      
      // Show variant metafield thumbnails
      if (thumbId && thumbId.includes('thumbnail-')) {
        shouldShow = true;
      }
      // Show featured image thumbnail
      else if (dataTarget && featuredMediaId && dataTarget.includes(featuredMediaId)) {
        shouldShow = true;
      }
      
      if (shouldShow) {
        thumb.style.display = '';
        thumb.classList.remove('hidden');
        thumb.removeAttribute('hidden');
      } else {
        thumb.style.display = 'none';
        thumb.classList.add('hidden');
        thumb.setAttribute('hidden', '');
      }
    });
  }

  updateSlider(visibleCount) {
    const sliderComponent = this.mediaGallery.querySelector('slider-component');
    if (!sliderComponent) return;
    
    const slider = sliderComponent.querySelector('.slider');
    if (!slider) return;
    
    // Reset slider position to first visible item
    const firstVisibleItem = slider.querySelector('.product__media-item:not([style*="display: none"]):not(.hidden)');
    if (firstVisibleItem) {
      // Remove active class from all
      slider.querySelectorAll('.product__media-item').forEach(item => {
        item.classList.remove('is-active');
      });
      
      // Add active to first visible
      firstVisibleItem.classList.add('is-active');
      
      // Scroll to first visible item
      firstVisibleItem.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'start' });
    }
    
    // Update slider component if it has an update method
    if (typeof sliderComponent.update === 'function') {
      sliderComponent.update();
    }
  }

  updateMediaCounter(visibleCount) {
    const counterTotal = this.mediaGallery.querySelector('.slider-counter--total');
    if (counterTotal) {
      counterTotal.textContent = visibleCount;
    }
    
    const counterCurrent = this.mediaGallery.querySelector('.slider-counter--current');
    if (counterCurrent) {
      counterCurrent.textContent = '1';
    }
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new VariantMediaVisibility());
} else {
  new VariantMediaVisibility();
}